import { withMetadata } from '../metadata'
import { searchPhoneNumbersInText as _searchPhoneNumbersInText } from '../../core/index'

export function searchPhoneNumbersInText() {
	return withMetadata(_searchPhoneNumbersInText, arguments)
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/libphonenumber-js/min/exports/searchPhoneNumbersInText.js
// module id = 629
// module chunks = 0